import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.CajaRuta;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
    onGuardar: () => Promise<void>;
    nuevo: boolean;
}

/**
* Valida un CajaRuta
*/
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = { 
        IdSubtipoRemolque: validation.required,
        Nombre: validation.required,
        StatusPuerta: validation.required,
     };
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
export class CajaRutaFormNoRx extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    render() {
        const { value, onGuardar, nuevo } = this.props;
        const getField = this.getField;

        const hasError = this.hasError(this.props);
        const Text = getField(kea.Text);
        const Number = getField(kea.Number);
        const StatusPuerta = getField(selectores.StatusPuertaCaja);

        const CpSatSubTipoRem = getField( selectores.CpSatSubTipoRem);

        const CpSatTipoPermisoSelector = getField( selectores.CpSatConfigAutotransporteSelector);

        return (
            <div>
                <kea.Title titulo="Caja de ruta" onRegresar={() => history.go("/catalogos/CajaRuta")} />
                {kea.autogrid(6, [
                    <Text field="Nombre" />,
                    <Number field="Capacidad" />,
                    <StatusPuerta field="StatusPuerta" />,
                    <Text field="PlacaRemolque" />,
                    <CpSatSubTipoRem field="IdSubtipoRemolque" label="Subtipo remolque sat" />,
                ])}

                <div className="row">
                    <div className="col-md-12">
                        <kea.GuardarButton onClick={onGuardar} disabled={hasError} />
                    </div>
                </div>
            </div>);
    }
}

export const CajaRutaForm = componentToRx(CajaRutaFormNoRx);



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/cajasruta/edit/form.tsx